<template>
  <a-switch v-model="localValue" @change="onChange">
  </a-switch>
</template>

<script>
  import { noop } from 'lodash'
  export default {
    props: {
      onChange: {
        type: Function,
        default: noop
      },
      value: {
        type: Boolean,
        required: true,
        default: false
      }
    },
    computed: {
      localValue: {
        get() {
          return this.value
        },
        set(localValue) {this.$emit('input', localValue)}
      }
    },
  }
</script>

<style lang='stylus'>
</style>